import angular from 'angular';
import reviewComponent from './review.component';

let reviewModule = angular.module('review', [
  'ui.router'
])
.component('review', reviewComponent);

export default reviewModule;



// WEBPACK FOOTER //
// ./client/pages/review/review.js